import { Divider } from "@mui/material"

const CustomDivider = () =>
    <Divider
        sx={{
            position: 'absolute',
            bottom: 0,
            left: "-50%",
            border: '1px solid #39363255',
            width: '200%',
        }}
        variant="fullWidth"
    />

export default CustomDivider